const getHashStack = () => window.location.hash.slice(1).split('/').filter(Boolean);

const replaceHashStack = (stack) => {
    const url = new URL(window.location.href);
    url.hash = stack.join('/');
    window.history.replaceState(null, '', url);
};

export default function setupBootstrapModalsForBackButtonFunctionality() {
    if (!window.jQuery || typeof $.fn.modal !== 'function') return;
    const modals = document.querySelectorAll('.modal');
    if (!modals.length) return;

    const modalsObj = {};
    modals.forEach((modal) => {
        if (modal.id) modalsObj[modal.id] = $(modal);
    });

    // Bootstrap modali nisu deep-linkable; režemo stack na prvom od njih.
    const initialStack = getHashStack();
    const firstOwnIndex = initialStack.findIndex((segment) => segment in modalsObj);
    if (firstOwnIndex !== -1) {
        replaceHashStack(initialStack.slice(0, firstOwnIndex));
    }

    // Id-evi modala koje trenutno smatramo otvorenima. Potrebno jer ručno dispatchan
    // hashchange nema upotrebljive oldURL/newURL vrijednosti.
    const openIds = new Set();

    window.addEventListener('hashchange', () => {
        const stack = getHashStack();
        Object.keys(modalsObj).forEach((id) => {
            const isInStack = stack.includes(id);
            const wasOpen = openIds.has(id);
            if (wasOpen && !isInStack) {
                openIds.delete(id);
                modalsObj[id].modal('hide');
            } else if (!wasOpen && isInStack) {
                openIds.add(id);
                modalsObj[id].modal('show');
            }
        });
    });

    $(document).on('shown.bs.modal', (event) => {
        const id = event.target?.id;
        if (!id || !(id in modalsObj)) return;
        openIds.add(id);
        const stack = getHashStack();
        if (!stack.includes(id)) {
            window.location.hash = [...stack, id].join('/');
        }
    });

    $(document).on('hidden.bs.modal', (event) => {
        const id = event.target?.id;
        if (!id || !(id in modalsObj)) return;
        openIds.delete(id);
        const stack = getHashStack();
        const index = stack.indexOf(id);
        // Već je maknut iz hasha (npr. zatvoren putem Back tipke).
        if (index === -1) return;
        if (index === stack.length - 1) {
            window.history.back();
            return;
        }
        // Nije na vrhu: makni ga i sve iznad njega.
        // replaceState ne okida hashchange, pa ga ručno dispatchamo da se ostali modali sinkroniziraju.
        replaceHashStack(stack.slice(0, index));
        window.dispatchEvent(new HashChangeEvent('hashchange'));
    });
}
